import React from 'react';
import { connect, useSelector } from 'react-redux';
import { updateEpikBox } from '../../../actions/EpikBoxes';

const ReportListRow = ({ report, onBoxClick }) => {
  const user = useSelector(state => state.AppState.user);

  const allowedAssetsReportRoles = ['superAdmin', 'companyGroupAdmin'];
  if (report?.reportSymbol === 'PAR' && !allowedAssetsReportRoles?.includes(user?.role)) {
    return null;
  }

  const fieldClicked = () => {
    onBoxClick(report);
  };

  return (
    <tr className="row-hover">
      <td onClick={fieldClicked}>{report.reportName || ''}</td>
      <td>{report.owner}</td>
      <td>{report.sharingStatus}</td>
    </tr>
  );
};

const mapDispatchToProps = dispatch => ({
  updateBox: (token, report) => dispatch(updateEpikBox(token, report)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ReportListRow);
